import {Pipe, PipeTransform} from '@angular/core';
import {marked} from "marked";
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  name: 'markdown',
  standalone: true
})
export class MarkdownPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) { }
  transform(value: string | null): SafeHtml | null {
    if (value && value.length > 0) {
      return this.sanitizer.sanitize(1, marked(value));
    }
    return null;
  }
}
